import { LANGUAGE_DEFAULT, NError, NSuccess } from '@configs/const.config'
import { TResApi, TResApiErr, TResDataListApi } from '@configs/interface.config'
import { checkAuth } from '@src/libs/localStorage'
import { notification } from 'antd'
import { useMutation, useQuery } from 'react-query'
import { TPatchQuiz, TQueryQuiz, TQuiz } from '@src/modules'

import { queryClient } from '..'
import { createManyQuiz, createQuiz, getListQuiz, getQuizById, patchQuizById, removeQuizById } from '../apis'
import { DETAIL_QUIZ, LIST_QUIZ } from '../keys'

/**
 *
 * @method useMutationCreateQuiz
 * @returns
 */
export const useMutationCreateQuiz = () =>
  useMutation(createQuiz, {
    onSuccess: (res: TResApi<TQuiz>) => {
      queryClient.invalidateQueries([LIST_QUIZ]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

/**
 *
 * @method useMutationCreateManyQuiz
 * @returns
 */
export const useMutationCreateManyQuiz = () =>
  useMutation(createManyQuiz, {
    onSuccess: (res: TResApi<TQuiz[]>) => {
      queryClient.invalidateQueries([LIST_QUIZ]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

/**
 * @method useQueryListQuiz
 * @param {TQueryQuiz}params
 * @param {string}token
 * @param lang
 * @param enabled
 * @returns
 */
export const useQueryListQuiz = (params: TQueryQuiz, token?: string, lang = LANGUAGE_DEFAULT, enabled = false) => {
  const accessToken = token || checkAuth()
  return useQuery<TResDataListApi<TQuiz[]>>(
    [LIST_QUIZ, JSON.stringify(params), lang],
    () => getListQuiz(params, accessToken, lang),
    { enabled: !!accessToken && enabled },
  )
}

/**
 * @method useQueryQuizById
 * @param {string}id
 * @param {string}token
 * @param lang
 * @returns
 */
export const useQueryQuizById = (id: string, token?: string, lang = LANGUAGE_DEFAULT) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TQuiz>>([DETAIL_QUIZ, id, lang], () => getQuizById(id, token, lang), {
    enabled: !!accessToken && !!id,
  })
}

/**
 *
 * @method useMutationPatchQuizById
 * @returns
 */
export const useMutationPatchQuizById = () =>
  useMutation(({ id, data }: { id: string; data: TPatchQuiz }) => patchQuizById(id, data), {
    onSuccess: (res: TResApi, { id }) => {
      queryClient.invalidateQueries([LIST_QUIZ]).then()
      queryClient.invalidateQueries([DETAIL_QUIZ, id]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

/**
 *
 * @method useMutationRemoveQuizById
 * @returns
 */
export const useMutationRemoveQuizById = () =>
  useMutation((id: string) => removeQuizById(id), {
    onSuccess: (res: TResApi, id) => {
      queryClient.invalidateQueries([LIST_QUIZ]).then()
      queryClient.removeQueries([DETAIL_QUIZ, id])
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })
